import React, { useCallback } from "react";
import { PaginatedEntityTable } from "components/common";
import { fetchPaginatedCollections, keyFn } from "collections/hooks/useCollections";
import CollectionActions from "./CollectionActions";
import customColumnRenderers from "./customColumnRenderers";
import BulkActions from "./BulkActions";
export const DEFAULT_LAYOUT = {
  entityTableId: "collections",
  defaultPageSize: 20,
  defaultSort: { attributeId: "title", direction: "asc" },
  defaultDisplayedAttributes: ["title", "description", "shared_with_users", "shared_with_teams"],
  defaultColumnOrder: ["title", "description", "shared_with_users", "shared_with_teams"]
};
const bulkSelection = {
  actions: /* @__PURE__ */ React.createElement(BulkActions, null)
};
const CollectionsList = () => {
  const collectionActions = useCallback(
    ({ id, title }) => /* @__PURE__ */ React.createElement(CollectionActions, { id, title }),
    []
  );
  return /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "collections",
      entityActions: collectionActions,
      tableLayout: DEFAULT_LAYOUT,
      fetchEntities: fetchPaginatedCollections,
      keyFn,
      columnRenderers: customColumnRenderers,
      entityAttributesAreCamelCase: false,
      searchPlaceholder: "Search for collection",
      bulkSelection
    }
  );
};
export default CollectionsList;
